/* eslint-disable @typescript-eslint/no-unused-vars */
import { ofType } from 'redux-observable';
import { asyncScheduler, interval, of, scheduled } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  mergeAll,
  mergeMap,
  switchMap,
  takeUntil,
  withLatestFrom,
} from 'rxjs/operators';

import { calculateMarginSuccess } from 'actions/placeorder';
import { CALCULATE_MARGIN_REQUEST, STOP_CALCULATE_MARGIN } from 'actionTypes/placeorder';
import { calculateExtraOrderMargin } from 'helpers/formulas';
import {
  reduceOnlySelector,
  marginCalculationSelector,
} from 'selectors/placeOrderSelector';

const calculateMarginForNonPortfolioEpic = (action$, state$) =>
  action$.pipe(
    ofType(CALCULATE_MARGIN_REQUEST),
    takeUntil(action$.pipe(ofType(STOP_CALCULATE_MARGIN))),
    switchMap(() =>
      scheduled(
        [
          interval(10_000, asyncScheduler), // Regular updates every 10 seconds
          state$.pipe(map(marginCalculationSelector), distinctUntilChanged()),
          state$.pipe(map(reduceOnlySelector), distinctUntilChanged()),
        ],
        asyncScheduler
      ).pipe(
        mergeAll(),
        withLatestFrom(
          state$.pipe(map(reduceOnlySelector)),
          state$.pipe(map(marginCalculationSelector))
        ),
        filter(
          ([_, reduceOnly, marginCalculation]) => !!reduceOnly || !!marginCalculation
        ),
        mergeMap(([_, reduceOnly, marginCalculation]) => {
          // Handle reduce-only orders
          if (reduceOnly) {
            return of(calculateMarginSuccess(0));
          }

          // Skip if no calculation data available
          if (!marginCalculation) {
            return of();
          }

          const marginValue = calculateExtraOrderMargin(marginCalculation as any);
          return of(calculateMarginSuccess(marginValue));
        }),
        catchError(error => {
          console.error('Error calculating margin:', error);
          return of(); // todo - Consider dispatching an error action here
        })
      )
    )
  );

export { calculateMarginForNonPortfolioEpic };
